<template>
  <onex-dialog v-model="dialog" type="warning" max-width="500" @close="executeClose">
    <template #title> {{ $t('L_remove_beneficiary') }} </template>
    <template #text>
      {{ $t('L_remove_beneficiary_are_you_sure_you_want', { fullName: fullName }) }}
    </template>
    <template #yesBtn> {{ $t('L_yes_remove') }} </template>
    <template #noBtn> {{ $t('L_cancel') }} </template>
  </onex-dialog>
</template>

<script lang="ts">
import { mdiAlert } from '@mdi/js';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton, OnexDialog, Notifications } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'WarningDialogBeneficiary',
  components: {
    OnexButton,
    OnexDialog,
  },
  data: () => ({
    dialog: true,
    persistent: true,
    mdiAlert,
    Notifications,
  }),
  props: {
    deleteBeneficiary: {
      type: Function,
      default: () => undefined,
    },
    fullName: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    executeClose(yesClicked: boolean) {
      if (yesClicked) {
        this.$emit('deleteBeneficiary');
      } else {
        this.$emit('hideDialog');
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.close {
  float: right;
}

.orangeTop {
  border-top: 7px solid #ee7026;
}

.fontWeight600 {
  font-weight: 600;
}
</style>
